import Vue from "vue";

// 身份证校验
const validateIdCode = (rule, value, callback) => {
  let reg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
  if (!reg.test(value)) {
    callback(new Error("请输入正确的身份证号"));
  } else {
    callback();
  }
};

// 手机号校验
const validatePhoneNum = (rule, value, callback) => {
  let reg = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/;
  if (!reg.test(value)) {
    callback(new Error("请输入正确的手机号"));
  } else {
    callback();
  }
};

// 级联面板校验
const validCascader = (rule, value, callback) => {
  console.log(value);
  if (!value || !value[0]) {
    callback(new Error("该值不可为空"));
  } else {
    callback();
  }
};

export default function(Vue) {
  //添加全局API
  Vue.prototype.$commonFunc = {
    validateIdCode,
    validatePhoneNum,
    validCascader
  };
}



// WEBPACK FOOTER //
// ./src/utils/commonFunc.js